import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { UseHeader, MktEmpty } from '@cps'
import { useHistoryNew, waterfall, getPlatform } from '@utils'
import { ActivityAPI } from 'api/index'
import { ProductItem } from 'pages/mkt/components'
import mktController from 'controllers/mktController'
import { orderBy } from '@dt/fe-utils/dist/lodash'
import { memberMobx } from '@mobxStore'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const { isWeixinMiniProgram } = getPlatform()

const CouponPage: FC<IProps> = () => {
  const history = useHistoryNew()
  const [proList, setProList] = useState<any[]>([])
  const goDetail = (proInfo: any) => {
    history.push(`/groupBuy/detail/${proInfo.redeemProductId}`)
  }
  const getData = () => {
    ActivityAPI.getGroupBuyProduct().then((res: any) => {
      setProList(orderBy(res, (item: any) => item.seqencing))
    })
  }
  // Component Effect
  useIonViewWillEnter(() => {
    mktController.checkLogin(history).then(() => {
      getData()
    })
  })
  // 瀑布流实现
  useEffect(() => {
    mktController.initShareData({
      url: isWeixinMiniProgram ? `/pages/launch/index?jumpH5Page=${encodeURIComponent(location.href)}` : location.href,
      title: i18n.t('mkt.groupBuy.groupBuy2'),
    })
    const timer = setTimeout(() => {
      waterfall('water-fall-container', proList.length, 12)
    }, 0)
    return () => clearTimeout(timer)
  }, [proList])
  return (
    <IonPage className='groupBuy-page'>
      <UseHeader title={i18n.t('mkt.groupBuy.groupBuy2')} onBack={() => mktController.goBack(history)}></UseHeader>
      <IonContent className='page-content'>
        <div className='page-body'>
          {proList.length === 0 && <MktEmpty />}
          <div className='pro-area'>
            <div className='water-fall-container'>
              {
                proList.map((item: any) => (
                  <div className='pro-block' key={item.redeemProductId}>
                    <ProductItem
                      showSoldNum={memberMobx.brandConfig.isShowRedeemMoneySale}
                      info={item} onDetail={() => goDetail(item)}
                    >
                    </ProductItem>
                  </div>)
                )
              }
            </div>
            <div className='bottom-bar'></div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(CouponPage)
